import { PoolTypes, WeeklyReportResponse } from '../../models/weekly-report.model';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { WeeklyReportService } from '../../services/weekly-report.service';
import { ModalSnackbarService } from '../../services/modal-snackbar.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { floor2dpString, getAdToYm, getNextAd, getPrevAd } from '../../misc/functions';
import { pad, roundToScale, toDec } from '../../misc/bcmath';

@Component({
  selector: 'app-monthly-profit-simple',
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule, FormsModule],
  templateUrl: './monthly-profit-simple.component.html',
  styleUrls: ['./monthly-profit-simple.component.scss']
})
export class MonthlyProfitSimpleComponent implements OnInit {
  isLoaded = false;

  poolTypes = [...new Set(PoolTypes.filter(x => !['AX2', 'TH2', 'TH2年金'].includes(x) ))]; // AX2 TH2 TH2年金は非公開

  data: {[key: number]:WeeklyReportResponse} = {};

  ads: number[] = [];

  ts: number = 0;

  @ViewChild('tableWrapper') tableWrapper!: ElementRef;

  constructor(
    private router: Router,
    private service: WeeklyReportService,
    private snackBar: ModalSnackbarService,
  ) {}

  ngOnInit(): void {
    this.initialLoad();
  }

  rightScroll() {
    const el = this.tableWrapper.nativeElement;
    el.scrollLeft = el.scrollWidth;
  }
  async initialLoad() {

    this.data = {};
    let ad = 202507;  // 202507 から新システム稼働開始

    while(true) {
      const res = await lastValueFrom(this.service.getAll(ad));

      if (res) {
        if ((res as any).success === false) {
          break;
        }


        this.ads.push(ad);
        this.data[ad] = res;

        const tmp = new Date(res[3].updated_at).getTime();
        this.ts = Math.max(this.ts, tmp);

        ad = getNextAd(ad);
      }
      else {
        break;
      }
    }

    this.isLoaded = true;

    setTimeout(() =>{
      this.rightScroll();
    }, 100);
  }

  ym(ad: number) {
    const tmp = ad.toString();
    return tmp.substring(0, 4) +  "年" + tmp.substring(4, 6) + "月";
  }

  get updated() {
    const dt = new Date(this.ts);
    return dt.getFullYear() + '年' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日';
  }

  getProfit(ad: number, type: string) {
    const record = this.data[ad];

    if (!record) return "";

    const plstr = record[4].reports[type].sum_per ?? '0';
    const pl = parseFloat(plstr) * 100 / 100;

    const sign = (pl > 0) ? '+' : '';

    return sign + roundToScale(toDec(pl), 2, 'asym').toFixed(2) + '%';
  }

  isNegativeProfit(ad: number, type: string) {
    const pl = this.getProfit(ad, type);
    return (pl[0] === '-');
  }
}
